// TODO: basecoat really should export the dist/js/basecoat.js file.
// Then we could do:
//     import "basecoat-css/basecoat";
//      import "basecoat-css/toast";
// For now let's just import everything, and let esbuild tree-shake the unused stuff
import "basecoat-css/all"

import * as Turbo from "@hotwired/turbo"

import { setupStimulus } from "./controllers/stimulus"
import { hasAnyUnresolved, flushAll, beaconAll } from "./lib/pending_saves"
setupStimulus()

// Page-lifecycle guards for the autosave registry. Without these, fast
// Turbo navigation, tab close, or mobile pagehide can drop edits that
// were still inside the 500ms debounce window.

document.addEventListener("turbo:before-visit", async (event) => {
    if (!hasAnyUnresolved()) return
    event.preventDefault()
    const allSaved = await flushAll()
    if (allSaved) {
        Turbo.visit(event.detail.url)
        return
    }
    // A save couldn't land (412 stale, 403 dead session, network gone).
    // The controller already showed a toast explaining what happened; ask
    // before throwing away the local edit. Default to "stay" — silently
    // proceeding is exactly the bug this guard exists to prevent.
    if (window.confirm("Some changes couldn't be saved. Leave anyway and discard them?")) {
        Turbo.visit(event.detail.url)
    }
})

window.addEventListener("beforeunload", (event) => {
    if (!hasAnyUnresolved()) return
    event.preventDefault()
    // Older browsers required a returnValue assignment to trigger the prompt;
    // modern browsers ignore the string but still need preventDefault().
    event.returnValue = ""
})

// pagehide / visibilitychange are the reliable signals on mobile / tab
// suspend where beforeunload may never fire. The browser will not wait
// for promises here, so we dispatch synchronous keepalive requests via
// each entry's flushBeacon().
window.addEventListener("pagehide", beaconAll)
document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") beaconAll()
})

document.addEventListener("turbo:render", (event) => {
    // basecoat should actually do this via a mutation observer,
    // but there seems to be some bug. Quick fix for now:
    window.basecoat.stop()
    window.basecoat.initAll()
    window.basecoat.start()
})

// CSRF token management for Turbo Frames
document.addEventListener("turbo:before-fetch-response", (event) => {
    const csrfToken = event.detail.fetchResponse.response.headers.get("x-csrf-token")
    if (csrfToken != "") {
        updateCSRFMetaTag(csrfToken)
    }
})

function updateCSRFMetaTag(token) {
    const metaTag = document.querySelector('meta[name="csrf-token"]')
    if (metaTag && metaTag.content !== token) {
        metaTag.content = token
    }
}

console.log("Hello from Koala! 🐨")
